import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c54c6aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "パスワード更新", -1))
const _hoisted_2 = {
  id: "change-password-form",
  class: "card"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "current-password" }, "現在のパスワード", -1))
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "current-password" }, "新しいパスワード", -1))
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "current-password" }, "新しいパスワードをもう一度入力してください。", -1))
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "mt-5" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
          class: "card-body"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.currentPassword }]),
              id: "current-password",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.currentPassword) = $event)),
              autocomplete: "off"
            }, null, 2), [
              [_vModelText, _ctx.values.currentPassword]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.currentPassword)
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.newPassword }]),
              id: "current-password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.values.newPassword) = $event)),
              autocomplete: "new-password"
            }, null, 2), [
              [_vModelText, _ctx.values.newPassword]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.newPassword)
            }, null, 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "current-password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event))
            }, null, 512), [
              [_vModelText, _ctx.confirmPassword]
            ])
          ]),
          (_ctx.requestError)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "alert alert-danger",
                textContent: _toDisplayString(_ctx.requestError)
              }, null, 8, _hoisted_11))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger float-right",
              disabled: !_ctx.meta.valid,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args)))
            }, "パスワード更新", 8, _hoisted_13)
          ])
        ], 32)
      ])
    ]),
    _: 1
  }))
}